import React from 'react';

import {Modal, ModalHeader, ModalBody} from 'Components/Modal';

import {translation} from 'Services/TranslationHelpers';

export default class GameModal extends React.Component {
    /**
     * @method onClose
     */
    onClose = () => {
        const {onClose, handleStartCallback} = this.props;

        handleStartCallback();
        onClose();
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {type, antivirusPoints} = this.props;

        let title = null;
        let subtitle = null;
        let bio = null;

        if (type === 'virus') {
            title = 'OOPS!';

            subtitle = 'You have got a Virus.';

            bio = <>
                Believe it or not, devices can still get viruses and that includes mobiles. 
                Device Security offers real-time protection for your PC, Mac ®, 
                and mobile devices against ransomware, viruses, spyware, malware, 
                and other online threats.
            </>;
        } else if (type === 'hacker') {
            title = 'OH NO!';

            subtitle = 'You have been caught by a Cybercrook on the Dark Web.';

            bio = <>
                Online fraud and data breaches are on the rise. 
                We’ll monitor your personal information on the dark 
                web and notify you should it be found, so you can act fast.
            </>;
        } else if (type === 'antivirus') {
            title = 'PROTECTION SHIELD';

            subtitle = antivirusPoints + ' extra points!'

            bio = <>
                We go further to keep you safe online. 
                EE Cyber Security powered by Norton &#8482; is an all-in-one 
                service which helps protects your devices and identity wherever you are.
            </>;
        }

        return (
            <Modal>
                <ModalHeader onClose={this.onClose} />

                <ModalBody>
                    <div className="flex flex-col justify-center items-center text-center gap-2 md:px-4">
                        <p className="text-app-turquoise font-bold text-xl md:text-3xl">
                            {title}
                        </p>

                        <p className="text-lg md:text-2xl">
                            {subtitle}
                        </p>

                        {bio &&
                            <p>
                                {bio}
                            </p>
                        }
                    </div>
                </ModalBody>
            </Modal>
        )
    }
};
